import { dotnetApi } from '@gik/core/api/ky/dotnetApi';
import { useApi } from '@gik/core/api/swr/useApi';

export async function getInvitationEmailAddressFromToken(token: string): Promise<{ email: string }> {
  const response = dotnetApi.get(`invitations/${token}`, {
    searchParams: {
      fields: 'email',
    },
  });

  return await response.json();
}

export function useInvitationEmailAddressFromToken(token: string) {
  return useApi<{ email: string }>(token ? `invitations/${token}` : null);
}

export async function acceptInvitation(routeId: string, invitationToken: string): Promise<void> {
  await dotnetApi.post(`inkinds/${routeId}/organizers/${invitationToken}/confirm`);
}
